/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('NotificationsCategories', function($scope, $http, $rootScope, $stateParams, $location, _$toast, _$breadcrumbs) {

    $scope.saveCategory = function() {
        $http.post('/administration/notifications/save', $scope.category)
            .success(function(result) {
                if(result == -1){
                    _$toast.message('Wybrana kategoria istnieje już w systemie');
                }else if (result) {
                    _$toast.message('Kategoria została zapisana');
                    $location.path('/app/administration/notifications');
                }
            });
    };

    $scope.deleteCategory = function(id) {
        $http.get('/administration/notifications/delete/' + id)
            .success(function(result) {
                $scope.getList();
                if (result == -1)
                    _$toast.message('Kategoria nie została usunięta gdyż jest wykorzystywana w wiadomościach lub zgłoszeniach');
                else if(result == -2)
                     _$toast.message('Kategorie nie została usunięta, gdyż jest domyślną kategorią zgłoszeń');
                else if (result == 1) {
                    _$toast.message('Kategoria została usunięta');
                }
            });
    };

    $scope.categories = [];
    $scope.showLoader = false;
    $scope.getList = function() {
        $scope.showLoader = true;
        $http.get('/administration/notifications/getlist')
            .success(function(list) {
                $scope.categories = list;
                $scope.showLoader = false;
            });
    };

    $scope.checkForm = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope._init = function() {
        $scope.action = $stateParams.action;
        $scope.languages = [];
        $http.get('/administration/language/getlist/')
            .success(function(result) {
                $scope.languages = result;
                if ($stateParams.action == 'add') {
                    $scope.category = {};
                    if(result.length == 1)
                      $scope.category.language_id = result[0].id;
                    _$breadcrumbs.push('Dodawanie kategorii');
                } else if ($stateParams.action == 'edit') {
                    _$breadcrumbs.push('Edycja kategorii');
                    $http.get('/administration/notifications/category/' + $stateParams.id)
                        .success(function(result) {
                            $scope.category = result;
                        });
                } else {
                    $scope.getList();
                }
            });
    };
    $scope._init();



});
